
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { URL } from "../Redux/common/url";
import React, { useEffect, useState } from "react";
// Logos
import Img1 from "../images/8-4.webp";
import Img2 from "../images/Img2.webp";
import Img3 from "../images/Img3.webp";
import Img4 from "../images/Img4.webp";
import Img5 from "../images/Img5.webp";
import Img6 from "../images/Img6.webp";
import Img7 from "../images/Img7.webp";
import Img8 from "../images/Img8.webp";
import Img9 from "../images/Img9.webp";
import Img10 from "../images/Img10.webp";
import Img11 from "../images/Img11.webp";

const CompanyLogoSlider = () => {
  const settings = {
  dots: false,
  arrows: false,
  infinite: true,
  speed: 2000,
  slidesToShow: 5,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 1500, // thoda delay rakho
  cssEase: "linear",
  pauseOnHover: true,
  responsive: [
    { breakpoint: 1024, settings: { slidesToShow: 4 } },
    { breakpoint: 768, settings: { slidesToShow: 3 } },
    { breakpoint: 480, settings: { slidesToShow: 2 } }, // ✅ ab 480px se niche 2 dikhega
  ],
};


  // const logos = useMemo(
  //   () => [Img1, Img2, Img3, Img4, Img5, Img6, Img7, Img8, Img9, Img10, Img11],
  //   []
  // );
       const [productLists, setProductLists] = useState([]);
         const [loading, setLoading] = useState(true);
       
         useEffect(() => {
           fetchProductList();
         }, []);
     console.log(productLists);
         const fetchProductList = async () => {
           try {
             const response = await fetch(`${URL.API_BASE_URL}/publicApi/projectListPublicNew`);
             if (!response.ok) throw new Error("Network response was not ok");
             const data = await response.json();
             setProductLists(data?.project || []);
             setLoading(false);
           } catch (error) {
             console.error("Fetch error:", error);
             setLoading(false);
           }
         };
       
         if (loading) return <p className="text-center py-5">Loading...</p>;
  return (

<section className="container-fluid my-5 px-3">
  <h1 className="text-center mb-4 fw-bold" style={{ color: '#079000'}}>
    Trusted by <span className="text-dark">2,500+</span> world-class brands
  </h1>

  <Slider {...settings}>
  {productLists && productLists.length > 0 ? (
            productLists.map((item, index) => (
      <div key={index} className="px-2">
        <div className="d-flex justify-content-center align-items-center">
          <img
           src={URL?.API_BASE_URL + item?.feature_image}
             alt={item.feature_image}
            className="img-fluid"
            style={{ maxHeight: "120px", objectFit: "contain" }}
          />
        </div>
      </div>
                                        ))
          ) : (
            <p>Loading...</p>
          )}
  </Slider>
</section>

  );
};

export default CompanyLogoSlider;
